/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterDevice = new PostFilter(
  [['guid', PostFilterComparison.eq]],
  'experiments.protocolDevices.device',
);

export const getPostFilterDevice = (path?: string) =>
  new PostFilter(
    [['guid', PostFilterComparison.eq]],
    path ? path : 'device',
  );
